import { render, staticRenderFns } from "./page-content-type-sp_pricing.vue?vue&type=template&id=c71e6be0&scoped=true"
import script from "./page-content-type-sp_pricing.vue?vue&type=script&lang=js"
export * from "./page-content-type-sp_pricing.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-sp_pricing.vue?vue&type=style&index=0&id=c71e6be0&prod&lang=scss"
import style1 from "./page-content-type-sp_pricing.vue?vue&type=style&index=1&id=c71e6be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71e6be0",
  null
  
)

export default component.exports